import { Typography, Stack, Avatar, Tooltip, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { DailiesStreaks, Winner } from '.';
import { resizeImage } from '../../api/cloudinary';

type PropTypes = {
  dailiesStreaks: DailiesStreaks;
  streakCategory: 'played' | 'timeouts' | 'scratches';
};

export const Streaks = ({ dailiesStreaks, streakCategory }: PropTypes) => {
  const theme = useTheme();
  const [leaders, setLeaders] = useState<Winner[]>();
  const [chasers, setChasers] = useState<Winner[]>();
  const [title, setTitle] = useState<string>('');
  const [allTimeStat, setAllTimeStat] = useState<number>();

  useEffect(() => {
    if (streakCategory === 'played') {
      setLeaders(dailiesStreaks?.usersPlayedTop);
      setChasers(dailiesStreaks?.usersPlayedChasers);
      setTitle('Consecutive Played');
      setAllTimeStat(
        dailiesStreaks?.usersPlayedTop[0].dailiesStats
          .consecutiveDailiesPlayedAllTime
      );
    }
    if (streakCategory === 'timeouts') {
      setLeaders(dailiesStreaks?.usersNoTimeOutTop);
      setChasers(dailiesStreaks?.usersNoTimeOutChasers);
      setTitle('No Timeouts');
      setAllTimeStat(
        dailiesStreaks?.usersNoTimeOutTop[0].dailiesStats
          .consecutiveDailiesNoTimeOutsAllTime
      );
    }
    if (streakCategory === 'scratches') {
      setLeaders(dailiesStreaks?.usersParOrBetterTop);
      setChasers(dailiesStreaks?.usersParOrBetterChasers);
      setTitle('Scratches');
      setAllTimeStat(
        dailiesStreaks?.usersParOrBetterTop[0].dailiesStats
          .consecutiveDailiesParOrBetterAllTime
      );
    }
  }, [streakCategory]);

  return (
    <>
      <Typography
        fontWeight={600}
        mb={1}
        sx={{
          textShadow:
            theme.palette.mode === 'dark'
              ? `0 0 0px ${theme.palette.dailies.main}, 0 0 0px ${theme.palette.dailies.main}, 0px 0px 16px ${theme.palette.dailies.main}`
              : 'none',
        }}
      >
        {title}
      </Typography>
      <Stack spacing={2}>
        <Typography fontWeight={600}>All Time</Typography>
        <Typography
          variant="h5"
          sx={{
            textShadow:
              theme.palette.mode === 'dark'
                ? `0 0 0px ${theme.palette.dailies.main}, 0 0 0px ${theme.palette.dailies.main}, 0px 0px 16px ${theme.palette.dailies.main}`
                : 'none',
          }}
        >
          {allTimeStat}
        </Typography>
        <Stack
          direction={'row'}
          sx={{
            flexWrap: 'wrap',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {leaders?.map((u) => (
            <Tooltip title={u.username} placement="top">
              <Avatar
                src={resizeImage(u.avatarPublicId, 50, 50)}
                variant="rounded"
                sx={{ margin: '2px', height: 35, width: 35 }}
              />
            </Tooltip>
          ))}
        </Stack>
        <Stack
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography fontWeight={600} mb={2}>
            Current Chasers
          </Typography>
          {chasers?.map((u) => (
            <Stack
              direction={'row'}
              spacing={2}
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Avatar
                src={resizeImage(u.avatarPublicId, 50, 50)}
                variant="rounded"
                sx={{
                  height: 25,
                  width: 25,
                }}
              />
              <Typography
                sx={{
                  lineHeight: '25px',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  width: '150px',
                }}
              >
                {' '}
                {u.username}
              </Typography>
              <Typography>
                {' '}
                {streakCategory === 'played'
                  ? u.dailiesStats.consecutiveDailiesPlayedCurrent
                  : streakCategory === 'timeouts'
                  ? u.dailiesStats.consecutiveDailiesNoTimeOutsCurrent
                  : streakCategory === 'scratches'
                  ? u.dailiesStats.consecutiveDailiesParOrBetterCurrent
                  : null}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </>
  );
};
